// This file should only contain action type constants.

export const SET_QUICK_SPECS = 'SET_QUICK_SPECS';
export const SET_VEHICLE_TYPE = 'SET_VEHICLE_TYPE';
export const SET_QUICK_SPECS_IDC = 'SET_QUICK_SPECS_IDC';
